import { render } from "./LegoDatepickerInput.vue?vue&type=template&id=451de9c8"
import script from "./LegoDatepickerInput.vue?vue&type=script&lang=js"
export * from "./LegoDatepickerInput.vue?vue&type=script&lang=js"

import "./LegoDatepickerInput.vue?vue&type=style&index=0&id=451de9c8&lang=scss"
script.render = render

export default script